import styled from "@emotion/styled";

const Box = styled.div`
  box-sizing: border-box;
`;

export default Box;